const crypto = require('crypto');
const algorithm = 'aes-256-cbc'; //Using AES encryption
//const key = '56b006087f4647c643b83db4fe47ad85' //crypto.randomBytes(32);
//const iv = '815aca42146a483b2e9b1ca97e0b0a5005a5644027e5e08e76e16095857ce741'//crypto.randomBytes(16);
//const key = crypto.randomBytes(32);
//const iv = crypto.randomBytes(16);
const key = Buffer.from('56b006087f4647c643b83db4fe47ad85');
const iv = Buffer.from('815aca42146a483b');

//Encrypting text
module.exports.encryptData = (text) => {
   let cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv);
   let encrypted = cipher.update(text);
   encrypted = Buffer.concat([encrypted, cipher.final()]);
   return encrypted.toString('hex') ;
}

// Decrypting text
module.exports.DencryptData = (text) => {
   //let iv = Buffer.from(iv, 'hex');
   let encryptedText = Buffer.from(text, 'hex');
   let decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), iv);
   let decrypted = decipher.update(encryptedText);
   decrypted = Buffer.concat([decrypted, decipher.final()]);
   return decrypted.toString();
}



// WEBPACK FOOTER //
// ./src/util/CriptografiaAES.js